export default "__VITE_ASSET__ilT5Uf19__"